import React from "react";

export function ToastDialog({ Component, onClose, ...props }) {
  return (
    <Component {...props} onClose={onClose}></Component>
  );
}

